// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3YLQI","col":"styles_col__1tyt7"};